import React from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import glowBooster from '../../assets/glow_booster.png';
import energyBoost from '../../assets/energy-boost.png';
import proAge from '../../assets/pro-age.png';
import hyaluMinerals from '../../assets/hyalu_minerals.png';
import { useAppContext } from '../AppContext';

export const Page3: React.FC = () => {
    const navigate = useNavigate(); // Initialize useNavigate
    const { openModal } = useAppContext();
    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px', backgroundColor: 'rgba(255, 250, 244, 1)' }}>
            <Typography
                sx={{
                    fontFamily: 'ClaireMurphy', // Apply your custom font
                    fontSize: {
                        xs: '30px',
                        sm: '40px',
                        md: '50px',
                    },
                    fontWeight: 400,
                    textAlign: 'center',
                    color: 'rgba(61, 61, 61, 1)',
                    marginBottom: '30px',
                }}
            >
                BIELENDA SUPREMELAB
            </Typography>
            <Grid container spacing={4} justifyContent="center" alignItems="stretch">
                {[
                    {
                        id: 1,
                        title: 'Bielenda Supremelab Glow Booster Elixir - HYDRA GLOW',
                        volume: '30ml',
                        price: 'RM 383',
                        image: glowBooster,
                        path: '/product/hydra-glow',
                    },
                    {
                        id: 2,
                        title: 'Bielenda Supremelab Brightening Serum - ENERGY BOOST',
                        volume: '15ml',
                        price: 'RM 268',
                        image: energyBoost,
                        path: '/product/energy-boost',
                    },
                    {
                        id: 3,
                        title: 'Bielenda Supremelab Anti-Wrinkle Serum - PRO AGE EXPERT',
                        volume: '30ml',
                        price: 'RM 278',
                        image: proAge,
                        path: '/product/pro-age-expert',
                    },
                    {
                        id: 4,
                        title: 'Bielenda Supremelab Hydro-Serum - HYALU MINERALS',
                        volume: '30ml',
                        price: 'RM 348',
                        image: hyaluMinerals,
                        path: '/product/hyalu-minerals',
                    },
                ].map((product) => (
                    <Grid item xs={12} sm={6} md={3} key={product.id} display="flex">
                        <Card
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                width: '100%',
                                borderRadius: '20px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s',
                                cursor: 'pointer', // Add cursor pointer for indication
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                },
                            }}
                            onClick={() => navigate(product.path)} // Handle the click event to navigate
                        >
                            <Box sx={{ paddingX: '20px', paddingBottom: '20px', paddingTop: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1, maxHeight: '300px', height: '300px' }}>
                                <CardMedia
                                    component="img"
                                    image={product.image}
                                    alt={product.title}
                                    sx={{
                                        maxHeight: '300px',
                                        height: '300px',
                                        width: 'auto',
                                        objectFit: 'contain',
                                        borderRadius: '36px'
                                    }}
                                />
                            </Box>
                            <CardContent>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '30px',
                                        fontWeight: 500,
                                        lineHeight: '36px',
                                        letterSpacing: '-0.02em',
                                        textAlign: 'left',
                                        color: 'rgba(61, 61, 61, 1)',
                                        mb: 1,
                                    }}
                                >
                                    {product.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '18px',
                                        fontWeight: 400,
                                        lineHeight: '26.1px',
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        mb: 1,
                                    }}
                                >
                                    {product.volume}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '20px',
                                        fontWeight: 600,
                                        lineHeight: '25px',
                                        letterSpacing: '0.1em',
                                        textAlign: 'left',
                                        color: 'rgba(61, 61, 61, 1)',
                                        mb: 2,
                                    }}
                                >
                                    {product.price}
                                </Typography>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        borderColor: 'rgba(0, 48, 135, 1)',
                                        color: 'rgba(0, 48, 135, 1)',
                                        borderRadius: '50px',
                                        textTransform: 'uppercase',
                                        fontWeight: 600,
                                        width: '100%',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 48, 135, 1)',
                                            zIndex: 0,
                                            transform: 'translateX(-100%)',
                                            transition: 'transform 0.4s ease',
                                        },
                                        '&:hover::before': {
                                            transform: 'translateX(0)',
                                        },
                                        '&:hover': {
                                            borderColor: '#003365',
                                            color: '#fff',
                                        },
                                        '& .button-text': {
                                            position: 'relative',
                                            zIndex: 1,
                                        },
                                    }}
                                    onClick={(event) => {
                                        event.stopPropagation(); // Stop event propagation
                                        openModal();
                                    }}
                                >
                                    <span className="button-text">Buy Now</span>
                                </Button>


                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};
